import React from 'react';
import { Input, Select } from 'antd';
import { useLanguage } from '../../../contexts/LanguageContext';

const { TextArea } = Input;

const FONT_OPTIONS = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Microsoft JhengHei', label: '微軟正黑體' },
  { value: 'Microsoft YaHei', label: '微軟雅黑' },
  { value: 'PMingLiU', label: '新細明體' },
  { value: 'SimSun', label: '宋體' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'sans-serif', label: 'sans-serif' },
  { value: 'serif', label: 'serif' },
];

const TextBlockEditor = ({ formData, onFormChange }) => {
  const { t } = useLanguage();
  return (
    <div>
      <h3 style={{ margin: '0 0 20px 0', color: '#333' }}>{t('eformDesigner.editTextBlock')}</h3>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{t('eformDesigner.textContent')}:</label>
        <TextArea
          value={formData.content ?? formData.text ?? ''}
          onChange={(e) => onFormChange('content', e.target.value)}
          placeholder={t('eformDesigner.pleaseEnterTextContent')}
          rows={4}
          style={{ resize: 'vertical' }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{t('eformDesigner.textAlign')}:</label>
        <Select
          value={formData.textAlign || 'left'}
          onChange={(v) => onFormChange('textAlign', v)}
          style={{ width: '100%' }}
          options={[
            { value: 'left', label: t('eformDesigner.textAlignLeft') },
            { value: 'center', label: t('eformDesigner.textAlignCenter') },
            { value: 'right', label: t('eformDesigner.textAlignRight') },
            { value: 'justify', label: t('eformDesigner.textAlignJustify') },
          ]}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{t('eformDesigner.fontFamily')}:</label>
        <Select
          value={formData.fontFamily || ''}
          onChange={(v) => onFormChange('fontFamily', v)}
          style={{ width: '100%' }}
          allowClear
          placeholder={t('eformDesigner.pleaseSelect')}
          options={FONT_OPTIONS}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{t('eformDesigner.fontSize')}:</label>
        <Select
          value={formData.fontSize || '14px'}
          onChange={(v) => onFormChange('fontSize', v)}
          style={{ width: '100%' }}
          options={[
            { value: '12px', label: t('eformDesigner.small12px') },
            { value: '14px', label: t('eformDesigner.medium14px') },
            { value: '16px', label: t('eformDesigner.large16px') },
            { value: '18px', label: t('eformDesigner.extraLarge18px') },
            { value: '20px', label: t('eformDesigner.fontSize20px') },
            { value: '24px', label: t('eformDesigner.fontSize24px') },
          ]}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>{t('eformDesigner.fontStyle')}:</label>
        <Select
          value={formData.fontStyleType || 'normal'}
          onChange={(v) => onFormChange('fontStyleType', v)}
          style={{ width: '100%' }}
          options={[
            { value: 'normal', label: t('eformDesigner.normal') },
            { value: 'bold', label: t('eformDesigner.bold') },
            { value: 'italic', label: t('eformDesigner.italic') },
            { value: 'bold-italic', label: t('eformDesigner.boldItalic') },
            { value: 'underline', label: t('eformDesigner.underline') },
          ]}
        />
      </div>
    </div>
  );
};

export default TextBlockEditor;
